import React from 'react';
import './ErrorPage.css';
import Logo from '../../assets/images/brange_logo.png';

function ErrorPage({ code = 404 }) {

  return (
    <div className="split-error-page">
      <div className="error-left-panel">
        <div className="logo-wrapper">
          <img src={Logo} alt="Logo" className="error-logo" />
        </div>
        <div className="animated-background">
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
        </div>
      </div>

      <div className="error-right-panel">
        <h1 className="error-code-animated">{code}</h1>
        <p className="error-message">Oops! Página não encontrada.</p>
        <p className="error-description">
          Parece que você tentou acessar algo que não existe ou foi movido.
        </p>
        <button
            className="error-action-button"
            onClick={() => {
                const url = process.env.REACT_APP_LINK_URL || '/';
                window.location.href = url;
            }}
            >
            Voltar ao Início
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;